import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgWechat({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 9c3.292 0 6 2.438 6 5.5 0 1.758-.892 3.31-2.275 4.313l.613 1.532a.5.5 0 01-.688.633l-.076-.048-1.633-1.224c-.61.19-1.263.294-1.941.294-3.292 0-6-2.438-6-5.5S12.708 9 16 9zm0 2c-2.231 0-4 1.592-4 3.5s1.769 3.5 4 3.5 4-1.592 4-3.5-1.769-3.5-4-3.5zM9 3c2.67 0 5.081 1.402 6.262 3.591a1 1 0 11-1.76.95C12.674 6.005 10.943 5 9 5 6.22 5 4 7.035 4 9.5c0 2.19 1.764 4.076 4.17 4.438a1 1 0 11-.298 1.978 7.438 7.438 0 01-.852-.18l-1.893 1.419a.5.5 0 01-.8-.432l.015-.09.48-1.916C3.102 13.529 2 11.628 2 9.5 2 5.89 5.152 3 9 3zm5 10a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zM7 7a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgWechat
